import React from 'react';
import { NamedLink } from '../../../components';

import css from './CtSignupIntro.module.css';

// Container Trader: default account type for shoppers arriving from a listing.
export const CT_BUYER_USER_TYPE = 'Buyer';

const getIntent = from => {
  if (!from) return null;
  const path = from.split('?')[0];
  if (/\/checkout\/?$/.test(path)) return 'buy';
  if (/^\/l\//.test(path)) return 'contact';
  return 'continue';
};

const TITLES = {
  signup: {
    buy: 'Create a free account to finish your purchase',
    contact: 'Create a free account to contact the seller',
    continue: 'Create a free account to continue',
  },
  login: {
    buy: 'Log in to finish your purchase',
    contact: 'Log in to contact the seller',
    continue: 'Log in to continue',
  },
};

/**
 * Short explanation shown above the sign-up / log-in form when a shopper was sent here
 * from a listing (Buy now, Send an inquiry, Request a quote).
 */
const CtSignupIntro = props => {
  const { from, isLogin, showChooseTypeLink } = props;
  const intent = getIntent(from);
  if (!intent) return null;

  const title = TITLES[isLogin ? 'login' : 'signup'][intent];
  const backText =
    intent === 'continue'
      ? "You'll go right back to where you left off."
      : "You'll go right back to the container you were viewing.";

  return (
    <div className={css.root} role="note">
      <p className={css.title}>{title}</p>
      {isLogin ? (
        <p className={css.text}>{backText}</p>
      ) : (
        <ul className={css.list}>
          <li>Free to join. No membership or sign-up fee.</li>
          <li>Takes about a minute.</li>
          <li>{backText}</li>
        </ul>
      )}
      {showChooseTypeLink ? (
        <p className={css.small}>
          Signing up to sell containers or haul loads?{' '}
          <NamedLink
            name="SignupPage"
            to={{ state: { from, ctChooseType: true } }}
            className={css.link}
          >
            Choose a different account type
          </NamedLink>
        </p>
      ) : null}
    </div>
  );
};

export default CtSignupIntro;
